import React from 'react';

import { RemovePlanSetForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';

export type RemovePlanSetModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: RemovePlanSetModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Remove Plan Set'
      subTitle='Confirm you would like to remove the plan set and associated plans.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <RemovePlanSetForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
